import store from "../store";
import { storeGet, storeSet } from "../localStore";
import { SDKHB_APP_ID } from "../config";
import { getUser } from "@/apis/sdkhb";
import { sort_ASCII } from "@/libs/utils";

const sdkhbRoute = async (to, from, next) => {
  if (to.meta.unAuth) {
    next();
    return;
  }
  // 1.先判断store中有无userInfo
  const { userInfo } = store.state.sdkhb;
  if (userInfo.open_id) {
    console.log("用户信息存在", 1, userInfo);
    next();
    return;
  }
  // 2.判断URL中是否存在CODE参数
  if (locationSearchCode()) {
    // 如果存在CODE，则为授权页跳回
    const { code, state } = handleLocationSearch();
    console.log("code获取信息", 2, code, state);
    // 对被微信拼接了code参数的url处理下 处理掉code
    const _url = window.location.origin + window.location.pathname;
    window.history.replaceState({}, 0, _url);
    // 获取微信授权信息
    const r = await getUser({
      code: code,
      wx_app_id: to.meta.appId,
      sign: sort_ASCII({ code: code, wx_app_id: to.meta.appId }),
    });
    store.commit("sdkhb/CHANGE_USERINFO", { userInfo: r.content });
    storeSet(to.meta.appId === 'wx02a11d85d79282b2' ? "WX_SDK_OPEN_ID" : "OLD_SDK_OPEN_ID", r.content.open_id);
    // 未绑定过账号的跳转到账号绑定页面，否则跳转到角色选择页面
    if (r.content.status === 1) {
      next({ name: to.meta.appId === 'wx02a11d85d79282b2' ? "sdkhb-wxRole" : "sdkhb-role" });
      return;
    }
    next({ name: to.meta.appId === 'wx02a11d85d79282b2' ? "sdkhb-wxLogin" : "sdkhb-login" });
    return;
  }
  // 3.判断本地是否存着open_id
  const SDK_OPEN_ID = storeGet(to.meta.appId === 'wx02a11d85d79282b2' ? "WX_SDK_OPEN_ID" : "OLD_SDK_OPEN_ID");
  if (SDK_OPEN_ID) {
    // 如果存在，拿open_id换用户信息并且存store中
    console.log("本地缓存获取信息", 3, SDK_OPEN_ID);
    let r;
    try {
      // 如果拿openid换取用户信息接口返回错误 则清空缓存 重新加载页面
      r = await getUser({
        open_id: SDK_OPEN_ID,
        wx_app_id: to.meta.appId,
        sign: sort_ASCII({ open_id: SDK_OPEN_ID, wx_app_id: to.meta.appId }),
      });
    } catch (error) {
      console.error("open_id error");
      localStorage.clear();
      next({ path: "/sdkhb/" });
      return;
    }
    const userData = {
      ...r.content,
      open_id: SDK_OPEN_ID,
    };
    store.commit("sdkhb/CHANGE_USERINFO", { userInfo: userData });
    // 未绑定过账号的跳转到账号绑定页面，否则跳转到角色选择页面
    if (r.content.status === 1) {
      next({ name:  to.meta.appId === 'wx02a11d85d79282b2' ? "sdkhb-wxRole" : "sdkhb-role" });
      return;
    }
    next({ name: to.meta.appId === 'wx02a11d85d79282b2' ? "sdkhb-wxLogin" : "sdkhb-login" });
    return;
  }
  // 4.无open_id且store中也不存在用户信息，则跳开放平台获取code
  console.log("开放平台", 4, to.meta.appId);
  const redirect_uri = encodeURIComponent(window.location.href);
  const query = handleQuery(to.query);
  const state = `${to.name}_SDK_${query}`;
  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${to.meta.appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`;
};

// 判断是否为授权页跳回
const locationSearchCode = () => {
  try {
    const search = decodeURIComponent(window.location.search);
    const flag = search.indexOf("code") === -1 ? false : true;
    return flag;
  } catch (error) {
    console.log("授权页", error);
    return false;
  }
};

const handleLocationSearch = () => {
  // ?code=071ooabY1ZDee01tmA9Y1tsUaY1ooabb&state=
  try {
    let search = decodeURIComponent(window.location.search);
    search = search.slice(1);
    let obj = {};
    search = search.split("&state=");
    obj.code = search[0].split("=")[1];
    obj.state = search[1];
    return obj;
  } catch (e) {
    console.log("auth", e);
    return {};
  }
};

const handleQuery = (query) => {
  let arr = [];
  for (let it in query) {
    arr.push(`${it}=${query[it]}`);
  }
  arr = arr.join("_SDK_");
  return arr;
};

export default sdkhbRoute;
